import { createRoot, hydrateRoot } from "react-dom/client";
import axios from "axios";
import App from "./App";
import { AuthContextProvider } from "./Context/AuthContext";
import './i18n/i18n';

// Attach Authorization header with accessToken for all requests
axios.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {}
  return config;
});

// Admin/CMS paths only — public pages (blogs, etc.) must not hard-redirect on 401
const AUTH_REDIRECT_PATHS = [
  "/dashboard",
  "/add-blog",
  "/blog-list",
  "/category-list",
  "/subcategory-list",
  "/content-manager",
  "/add-user",
  "/user-list",
];

const shouldRedirectToLogin = () => {
  const path = window.location.pathname || "";
  if (path === "/login") return false;
  return AUTH_REDIRECT_PATHS.some(
    (p) => path === p || path.startsWith(`${p}/`)
  );
};

// Handle token expiration - redirect to login on 401 only for CMS routes
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      try {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("accessTokenExpiresAtUtc");
        localStorage.removeItem("userDetails");
        localStorage.removeItem("role");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("accessTokenExpiresAtUtc");
        sessionStorage.removeItem("userDetails");
        sessionStorage.removeItem("role");
      } catch (_) {
        // ignore storage errors
      }
      if (shouldRedirectToLogin()) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

const container = document.getElementById("root");
const app = (
  <AuthContextProvider>
    <App />
  </AuthContextProvider>
);

if (container && container.hasChildNodes()) {
  hydrateRoot(container, app);
} else if (container) {
  createRoot(container).render(app);
}
